/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="100" height="100" {...props}>
    <path
      fill="#B92A2E"
      fillRule="evenodd"
      d="M85.587 40.209c-3.333-7.847-10.207-13.287-16.784-13.287-10.929 0-12.41 3.864-18.303 3.754-5.892.11-7.374-3.754-18.304-3.754-6.576 0-13.45 5.44-16.783 13.287-3.872 9.12-2.462 18.03-.102 25.167 1.887 5.713 4.831 11.448 8.569 17.346 2.932 4.632 7 9.37 11.85 11.339 1.37.556 2.801.889 4.288.939 4.713 0 7.12-2.955 10.482-2.843C53.863 92.045 56.27 95 60.983 95c1.486-.05 2.918-.383 4.287-.94 4.85-1.969 8.919-6.706 11.85-11.338 3.738-5.898 6.683-11.633 8.57-17.346 2.359-7.137 3.769-16.047-.103-25.167z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#B92A2E"
      fillRule="evenodd"
      d="M50.254 29.92c.077 0 .155 0 .231-.002h.028a11.412 11.412 0 001.39-.055c-.992-6.957-2.003-11.889-4.765-18.378-2.152-.001-4.317-.197-4.501 2.606 4.193 4.768 5.954 10.318 6.549 15.78.34.032.694.05 1.068.05zM83.765 7.108s-7.71-2.75-17.481.417C57.009 10.53 51.89 20.57 51.902 23.924c0 .04 2.927-4.264 8.913-8.066 7.536-4.786 12.243-5.163 12.243-5.163s-5.753 1.428-12.382 6.169c-6.364 4.551-8.329 7.908-8.302 7.938 2.517 2.863 11.969 1.116 18.247-3.838 6.792-5.36 13.144-13.856 13.144-13.856z"
      clipRule="evenodd"
    ></path>
  </Svg>
)

export default Icon
